import { render } from "./Register.vue?vue&type=template&id=544b3870&scoped=true&bindings={\"state\":\"setup\",\"sendConfirm\":\"setup\",\"changeMessage\":\"setup\",\"agree_flg\":\"setup\",\"changeFlg\":\"setup\",\"csrf\":\"setup\"}"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=544b3870&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-544b3870"

export default script